import { Component, input } from '@angular/core';

@Component({
  selector: 'wl-progress-bar',
  standalone: true,
  templateUrl: './progress-bar.component.html',
  styleUrls: [
    './progress-bar.component.ed.scss',
    './progress-bar.component.essent.scss',
  ],
})
export class ProgressBarComponent {
  readonly percentage = input.required<number>();
}
